import React, { useState } from "react";
import { AssetInterface } from "../../../../../models/AssetModel/Asset";
import { useLanguageStore } from "../../../../../store/useLanguageStore";
import { useDarkModeStore } from "../../../../../store/useDarkModeStore";
import { darkModeBackgroudInputs } from "../../../../../utils/constants";
import ToastMessage from "../../../../../common/ToastMessage";
import ClassOutlinedIcon from "@mui/icons-material/ClassOutlined";
import useUpdateAsset from "../../../../../store/ReactQueries/assets/asset/useUpdateAsset";
import useAssetCategories from "../../../../../store/ReactQueries/assets/assetCategories/useAssetCategories";

interface SelectCategoryProps {
  categoryId: string;
  asset: AssetInterface | undefined;
  page: number;
  pageSize: number;
}

export const SelectCategory: React.FC<SelectCategoryProps> = ({ asset, categoryId, page, pageSize }) => {
  const { language } = useLanguageStore();
  const { darkMode } = useDarkModeStore();
  const { data: assetCategories } = useAssetCategories(0, 0);

  const updateAsset = useUpdateAsset(page, pageSize);

  const [selectedItem, setSelectedItem] = useState<string>(categoryId);

  const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;
    if (asset) {
      const {
        id,
        barcode,
        assetCategoryId,
        title,
        assetTypeId,
        description,
        locationId,
        assetDepartmentId,
        assetStatusId,
        price,
        companyId,
        vendorId,
        boughtDate,
        warrantyDate,
        invoiceNo,
      } = asset;
      setSelectedItem(value);
      const upForm: AssetInterface = {
        id,
        barcode,
        assetCategoryId: value,
        title,
        assetTypeId,
        description,
        locationId,
        assetDepartmentId,
        assetStatusId,
        price,
        companyId,
        vendorId,
        boughtDate,
        warrantyDate,
        invoiceNo,
      };
      updateAsset.mutate(upForm, {
        onSuccess: () => ToastMessage.Success(),
        onError: (error) => {
          setSelectedItem(assetCategoryId);
          ToastMessage.Failed(error.message);
        },
      });
    }
  };

  return (
    <div title={language["AssetType"]} className="d-flex flex-row align-items-center gap-1" style={{ zIndex: 4 }}>
      <ClassOutlinedIcon sx={{ width: 13, height: 13, color: darkMode ? "white" : "initial" }} />
      <select
        className="select-asset"
        style={{ color: darkMode ? "white" : "initial", background: darkMode ? darkModeBackgroudInputs : "initial" }}
        value={selectedItem}
        onChange={(e) => {
          e.preventDefault();
          handleSelect(e);
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {assetCategories?.map(({ id, title }) => (
          <option key={id} value={id}>
            {title}
          </option>
        ))}
      </select>
    </div>
  );
};
export default SelectCategory;
